import { ColumnHelper } from "@tanstack/react-table";
import { BookingCalendar } from "PFApp/booking/types";
import Table from "PFComponents/table";
import { Typography } from "PFComponents/typography";
import { PaginatedCollection } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { BookingConfigSearch } from "../../booking_config_search";
import css from "./calendar_list.module.scss";

interface CalendarListProps {
  data: PaginatedCollection<BookingCalendar[]>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  term: string;
  setTerm: React.Dispatch<React.SetStateAction<string>>;
}

const CalendarList = ({ data, setPage, term, setTerm }: CalendarListProps): JSX.Element => {
  const { t } = useTranslation(["translation", "bookingModule"]);
  const generateColumns = (columnHelper: ColumnHelper<BookingCalendar>) => [
    columnHelper.accessor("name", {
      id: "name",
      header: t("translation:name"),
      cell: (info) => <div className={css.row}>{info.getValue()}</div>,
      enableSorting: false,
      size: 600
    })
  ];

  const history = useHistory();

  const handleEditCalendar = (calendar: BookingCalendar) => {
    history.push(`/admin/booking/calendars/${calendar.id}`);
  };

  const paginationOptions = {
    currentPage: data.meta.page || 1,
    onClick: setPage,
    totalPages: data.meta.totalPages || 1
  };

  return (
    <>
      <BookingConfigSearch onTermChange={setTerm} term={term} />
      {data.entries.length === 0 ? (
        <Typography variant="h4" className={css.notFound}>
          {t("bookingModule:config.noItemsFound")}
        </Typography>
      ) : (
        <Table<BookingCalendar>
          tableData={data.entries}
          generateColumns={generateColumns}
          onRowClick={handleEditCalendar}
          paginationOptions={paginationOptions}
          bottomElementsSize={100}
        />
      )}
    </>
  );
};

export default CalendarList;
